import { HttpClient } from '../httpClient';
import { EmailManagerServiceInterface } from './interfaces';

export class EmailManagerService implements EmailManagerServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async isValidEmail(email: string) {
    const { data } = await this.httpClient.post<{ valid: boolean }>(
      `/email-manager/email/validate`,
      {
        data: { email },
      },
    );

    return data.valid;
  }
}
